/**
 * creat by xcc
 * @description 展开收起组件
 */

import React, {useState} from 'react';
import "./unfold.css";
import {Button} from 'antd';

const ExpandableComponent = ({onChange}) => {
    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        setExpanded(!expanded);
        onChange(!expanded);
    };

    return (
        <>
            <div className="btn" onClick={handleToggle}>
                <Button icon={"filter"}>{expanded ? "收起筛选" : "更多筛选"}</Button>
                <style>{`.btn .anticon svg{width: 0.8em;height: 0.8em; margin-left: 0.2em;}`}</style>
            </div>
        </>
    );
};

export default ExpandableComponent;